import { changeClipPlaybackState, resetPlaybackClip, setMediaServerSeekProcessing, stopPlaybackClip, stopPlaybackTimeline } from 'actions/playback'
import { PREVIEW_MODE } from 'config/constants/preview'
import { PLAYBACK_STATE } from 'enums'
import { isEmpty } from 'lodash'
import { all, delay, put, select, takeEvery, takeLatest } from 'redux-saga/effects'
import { selectMediaServerSeekProcessing } from 'selectors/playback'
import * as ActionTypes from '~/actions/ActionTypes'
import { saveProject, saveTimeCodeModeAsProjectTimecodeFormat } from '~/actions/projectData/saveProject'


function* resetPlaybackState({ payload }) {
  const { id } = payload
  const selectedClip = yield select(state => state.playback.selectedClipId)
  const playingClip = yield select(state => state.playback.playingAsset)
  if (selectedClip === id || playingClip?.id === id) {
    yield put(changeClipPlaybackState(PLAYBACK_STATE.STOP))
    if (selectedClip === id) {
      yield put(resetPlaybackClip())
    }
  }
}


function* resetSourceMediaPreview({ type, payload }) {
  if ([ ActionTypes.DELETE_ASSETS, ActionTypes.RIPPLE_DELETE_ASSETS ].includes(type)) {
    const { assets } = payload
    if (!isEmpty(assets)) {
      const ioPointAssetID = yield select(state => state.preview.inOutPointsTimeLineAsset)
      const removedIOPointsAsset = assets.find(asset => asset.id === ioPointAssetID)
      if (removedIOPointsAsset) {
        yield put(resetPlaybackClip())
      }
    }
  }
}

function* onMediaServerSeekProcessing({ payload }) {
  const isMediaServerProcessing = yield select(selectMediaServerSeekProcessing)
  const { isProcessing } = payload
  if (isProcessing !== isMediaServerProcessing) {
    yield put(setMediaServerSeekProcessing(isProcessing))
  }
}

function* stopPlaying({ payload }) {
  const { mode } = payload
  switch (mode) {
    case PREVIEW_MODE.TIMELINE:
      yield put(stopPlaybackClip())
      break
    case PREVIEW_MODE.SOURCE:
      yield put(stopPlaybackTimeline())
      break
    default:
      break
  }
}

// Saving project with debounce effect
function* onSaveProject() {
  yield delay(500)
  const timeCodeMode = yield select(state => state.playback.timeCodeMode)
  yield put(saveTimeCodeModeAsProjectTimecodeFormat(timeCodeMode))
  yield put(saveProject())
}

function* watchAll() {
  yield all([
    takeEvery([ ActionTypes.SOURCE_FILE_DELETED ], resetPlaybackState),
    takeEvery([
      ActionTypes.DELETE_ASSETS,
      ActionTypes.RIPPLE_DELETE_ASSETS,
    ], resetSourceMediaPreview),
    takeEvery([ ActionTypes.EMIT_MEDIA_SERVER_SEEK_PROCESSING_STATUS ],
      onMediaServerSeekProcessing),
    takeEvery([ ActionTypes.SET_PREVIEW_MODE ],
      stopPlaying),
    takeLatest([
      ActionTypes.SET_TIME_CODE_MODE,
    ], onSaveProject),
  ])
}

export default watchAll
